<script lang="ts" setup>
import StandardsFilters from './Standards/index.ce.vue';
import CollectionsFilters from './Collections/index.ce.vue';
import UpdatesFilters from './Updates/index.ce.vue';
import { useSearchStore } from '../store/index.ts'
import { STANDARDS_SEARCH_TAB, COLLECTIONS_SEARCH_TAB, UPDATES_SEARCH_TAB } from '@/components/Search/constants.ts';

const props = defineProps({
    searchOnSelect: { type: Boolean, default: true },
    forMobile: { type: Boolean, default: false }
})


const searchStore = useSearchStore()

</script>

<template>
    <StandardsFilters  v-show="searchStore.activeTab == STANDARDS_SEARCH_TAB" :searchOnSelect="searchOnSelect" :forMobile="forMobile"></StandardsFilters>
    <CollectionsFilters  v-show="searchStore.activeTab == COLLECTIONS_SEARCH_TAB" :searchOnSelect="searchOnSelect" :forMobile="forMobile"></CollectionsFilters>
    <UpdatesFilters  v-show="searchStore.activeTab == UPDATES_SEARCH_TAB" :searchOnSelect="searchOnSelect" :forMobile="forMobile"></UpdatesFilters>
</template>
<style lang="scss">
    @use './style.scss';
</style>